import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { ChartModel } from 'src/app/models/chart.model';
import { Report } from 'src/app/models/report.model';
import { ChartsService } from 'src/app/services/charts.service';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { UserService } from 'src/app/services/user.service';
import { ViewsService } from 'src/app/services/views.service';
import { ManageChartComponent } from '../manage-chart/manage-chart.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  columns: ColumnDefinition[] = [
    { columnDef: 'rank', header: 'Rank', cell: (w: any) => `${w.rank}` },
    { columnDef: 'name', header: 'Name', cell: (w: any) => `${w.name}` },
    { columnDef: 'viewCount', header: 'Views', cell: (w: any) => `${w.viewCount}` }
  ];

  pushedChartColumns: string[] = ['name', 'views', 'countries', 'manage'];

  pushedCharts: ChartModel[];
  reportMetrics: any[] = [];
  pushedChartMetrics: any[] = [];
  isReportMetricsLoading: boolean = true;
  isChartMetricsLoading: boolean = true;
  pushedChartsDS = new MatTableDataSource();
  groupsForCharts = new Map();
  selectedChartsGroups: any[] = [];
  reports: Report[];
  userType = '';

  constructor(private chartsService: ChartsService, private usersService: UserService, private router: Router, private viewsService: ViewsService,
    public dialog: MatDialog, private clickstream: ClickStreamService, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    if (!this.usersService.user.isAdmin) this.router.navigate(['/dashboard']);

    this.userType = this.usersService.user.businessFunction;

    this.chartsService.getChartsPushedByUser().subscribe(result => {
      for (let i = 0; i < result.length; i++) {
        this.pushedChartMetrics.push({
          rank: i + 1,
          name: result[i].name,
          viewCount: result[i].viewCount,
          userCount: result[i].groupCount
        })
      }
      this.isChartMetricsLoading = false
      this.pushedCharts = result;
      this.pushedChartsDS.data = this.pushedCharts;
    });

    this.viewsService.getViewsForReports().subscribe((res: any[]) => {
      for (let i = 0; i < res.length; i++) {
        this.reportMetrics.push({
          rank: i + 1,
          name: res[i].name,
          viewCount: res[i].viewcount - 1 //defaults to one in the query for some reason
        })
      }
      this.isReportMetricsLoading = false;
    })
  }

  goToManageChart(chart: ChartModel) {
    const dialogRef = this.dialog.open(ManageChartComponent, {
      data: chart
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.removeRow) {
        this.pushedCharts = this.pushedCharts.filter(c => c.chartDataGuid != chart.chartDataGuid);
        this.pushedChartsDS.data = this.pushedCharts;
      }
    });

    this.clickstream.send('manage-chart', 'click', 'Admin Dashboard', 'Manage Pushed Chart', '', true);
  }
}
